import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

import OrderDetail from './views/OrderDetail.vue'
import Card from './components/Home/Card.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/main',
      component: Home,
      title: 'E-Logistic Web Tracking',
      children: [
        {
          path: '',
          redirect: '/main/about'
        },
        {
          path: 'home',
          name: 'Home',
          component: Card,
          meta: {
            title: 'E-Logistic Web Tracking'
          },
        },
        {
          path: 'order-detail/:orderNo',
          name: 'Order Detail',
          component: OrderDetail,
          meta: {
            title: 'Rincian Pesanan'
          },
        },
      ]
    },
    {
      path: '*',
      redirect: '/main/home'
    }
  ]
})

export default router
